const zh = {
  "comingSoon": "即将推出",
  "soonSub": "全新巨魔寻宝",
  "follow": "关注我们获取最新消息",
  "playNow": "现在就玩峡湾步道",
  "prev": "上一条路线",
  "next": "下一条路线",
  "of": "/",
  "readMore": "了解这条路线",
  "otherTrails": "更多路线即将推出",
  "partner": {
    "kicker": "面向企业与市政",
    "badge": "企业合作",
    "title": "成为 Trollfossjakten 合作伙伴。",
    "pitch": "酒店、咖啡馆、桑拿、滑雪场乃至整个市镇，都可以把自己的巨魔放上地图。寻宝游戏会把家庭和游客直接带到你门前——全年无休。",
    "points": [
      "你的店铺标注在巨魔地图上",
      "客人可用 Vipps 预订并付款",
      "首发价：前 50 位合作伙伴享 5 折"
    ],
    "cta": "成为合作伙伴",
    "cta2": "企业专区",
    "pin": "你的店铺在这里",
    "stamp": "5 折"
  },
  "names": {
    "partner": "成为合作伙伴",
    "fjord": "峡湾步道",
    "stairs": "午夜阳光阶梯",
    "farm": "Ågård 巨魔",
    "forest": "森林小径",
    "sea": "海怪航线"
  },
  "slides": {
    "stairs": {
      "kicker": "Spansdalen · Lavangen",
      "title": "午夜阳光阶梯：2117 级台阶上的 20 个巨魔。",
      "pitch": "一条木质阶梯沿 Spanstind / Ruŋgugáisá 山坡直上——爬升 380 米，俯瞰 Spansdalen 山谷和 Lavangen 峡湾。二十个巨魔在台阶上、观景台上和 Henrikka 瀑布旁等着你。",
      "stats": [
        [
          "20",
          "个巨魔"
        ],
        [
          "2117",
          "级台阶"
        ],
        [
          "380",
          "米爬升"
        ]
      ],
      "note": "六月和七月的午夜阳光下最美。"
    },
    "farm": {
      "kicker": "Lavangen · Troms",
      "title": "Ågård 巨魔：山谷对岸的 30 个巨魔。",
      "pitch": "山谷对岸一段全新的道路，经过红色农舍、干草架、牧羊草地和海岸。戴着针织帽的农场巨魔躲在篱笆和牛奶桶后面。",
      "stats": [
        [
          "30",
          "个巨魔"
        ],
        [
          "1",
          "条新路"
        ],
        [
          "4",
          "个季节"
        ]
      ],
      "note": "全新的道路——全新的巨魔。"
    },
    "forest": {
      "kicker": "Lavangen · Gratangen",
      "title": "森林小径：桦树与松树间的 25 个巨魔。",
      "pitch": "一条穿过长满苔藓的桦树和松树林的小路，经过开满棉花草的沼泽、潺潺小溪和小木桥。戴着蘑菇帽的苔藓巨魔从树干和石头后探出头来。",
      "stats": [
        [
          "25",
          "个巨魔"
        ],
        [
          "1",
          "条林间小径"
        ],
        [
          "4",
          "个季节"
        ]
      ],
      "note": "带上相机——还有巧克力。"
    },
    "sea": {
      "kicker": "Gratangen · Lavangen · Sjøvegan",
      "title": "海怪航线：捕获克拉肯和巨型海龟。",
      "pitch": "一条从 Gratangen 经 Lavangen 到 Sjøvegan 的峡湾乘船路线。水面下藏着海巨魔和两只 45 米长的巨兽——克拉肯，以及背上驮着一整座小岛的远古巨龟。",
      "stats": [
        [
          "15",
          "个海巨魔"
        ],
        [
          "45 米",
          "长的巨兽"
        ],
        [
          "3",
          "个港口"
        ]
      ],
      "note": "为付费游客准备的专属乘船套餐。"
    }
  }
};

export default zh;
